import React, { Component } from 'react';
import styles from './css-modules/audio_video.module.css';
import slideStyles from './css-modules/slide.module.css';
import { MdChevronRight } from "react-icons/md";

class VideoLink extends Component {
  constructor(props) {
    super(props);
    this.state = {color: '#D00024', sourceColor: '#D00024'}
  }

  componentDidMount() {
    if (this.props.inverted === true) {
      this.setState({
        color: '#FFEB3B',
        sourceColor: '#FFEB3B'
      })
    }
  }

  render () {
    return (
      <div className={styles.video_container} onClick={()=> this.props.setDisplayedOverlay(this.props.overlayArray)}>
        <div className={`${styles.imageContainer}`} style={this.props.imageStyle}>
          <img alt="" src={this.props.image} id={styles.videoImage}/>
        </div>
        {this.props.linkMessage && <span className={styles.videoLinkMessage} style={{color: this.state.color}}>{this.props.linkMessage}</span>}
        {this.props.linkSource && <span className={styles.videoLinkMessage} style={{color: this.state.sourceColor}}>{this.props.linkSource}</span>}
      </div>
    )
  }
}

export default VideoLink;
